export const getUrlParameter = (paramName) => {
    const searchString = window.location.search.substring(1);
    const params       = searchString.split("&");
    let i, val;

    for (i = 0; i < params.length; i++) {
        val = params[i].split("=");
        if (val[0].toLowerCase() === paramName.toLowerCase()) {
            return decodeURIComponent(val[1]);
        }
    }
    return '';
}